exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Backdrop-Backdrop__backdrop--Dm80Z{position:fixed;width:100%;height:100%;will-change:opacity;pointer-events:none}", ""]);
// Exports
exports.locals = {
	"backdrop": "src-components-Backdrop-Backdrop__backdrop--Dm80Z"
};